export const ERRORS = {
  OVER_LIMIT_ERROR: 'OverCachedQueryLimitError',
  TOO_MANY_QUERIES: 'TooManyQueriesInTheCurrentBillingPeriod',
  TOO_MANY_CACHED_QUERIES: 'TooManyCachedQueriesInTheCurrentBillingPeriod',
  RESOURCE_NOT_FOUND: 'ResourceNotFoundError',
};

export const CLONED_QUERY_DISPLAY_NAME = 'Clone';
export const CLONED_QUERY_NAME = '-clone';

export const DEFAULT_TIMEZONE = 'UTC';
